import React from 'react';
import styles from './Header.module.css';
import PropTypes from 'prop-types';
import { AppBar, Toolbar, Typography } from '@mui/material';
import Button from './../../UIElements/Button/Button';

function Header(props) {
    const { title, closeHandler } = props;

    return (
        <AppBar position="static" className={styles.ModalAppBar}>
            <Toolbar className={styles.ModalToolbar}>
                <Typography variant="h6" className={styles.Title}>
                    { title }
                </Typography>
                <div className={styles.ModalControls}>
                    <Button startIcon="close" role="icon" clickHandler={closeHandler} />
                </div>
            </Toolbar>
        </AppBar>
    )
}

Header.propTypes = {
    title: PropTypes.string,
    closeHandler: PropTypes.func
}

export default Header

